import React, { useState, useEffect } from 'react';
import { THEMES, type ThemeId } from '../types';

export const ThemeSelector: React.FC = () => {
  const [currentTheme, setCurrentTheme] = useState<string>('cosmic-universe');

  useEffect(() => {
    try {
      const saved = localStorage.getItem('echocondria-theme') || 'cosmic-universe';
      setCurrentTheme(saved);
      document.documentElement.dataset.theme = saved;
    } catch {
      // fallback
    }
  }, []);

  const handleThemeChange = (newTheme: string) => {
    setCurrentTheme(newTheme);
    document.documentElement.dataset.theme = newTheme;
    if (document.body) {
      document.body.dataset.theme = newTheme;
    }
    try {
      localStorage.setItem('echocondria-theme', newTheme);
    } catch {}
  };

  return (
    <div className="theme-selector-wrapper d-flex align-items-center gap-2">
      <label htmlFor="themeSelect" className="visually-hidden">Choose Theme</label>
      <div className="input-group input-group-sm">
        <span className="input-group-text bg-transparent border-secondary-subtle">
          <i className="bi bi-palette-fill"></i>
        </span>
        <select
          id="themeSelect"
          className="form-select form-select-sm"
          value={currentTheme}
          onChange={(e) => handleThemeChange(e.target.value)}
          data-theme-select
        >
          {THEMES.map((theme) => (
            <option key={theme.id} value={theme.id}>
              {theme.icon} {theme.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
